import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { ProductsService } from '../../../_services/products.service';
import { ImagesService } from '../../../_services/images.service';
import { environment } from '../../../../environments/environment';
import { ConfirmationService } from 'primeng/api';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.css'],
})
export class ProductImagesComponent implements OnInit {
  tabitems: any = [];

  productId: any;
  selectedProduct: any;
  productForm: FormGroup;

  role: any;
  routeRole: any;

  cookieStore: any;
  storeId: any;

  chooseFromImageBank = false;
  uploadNew = false;

  addMediaModal = false;
  mediaUploadType: any; // used to handle featured image upload against normal image upload
  imagesArray: any[] = [];
  selectedProductImagesArray: any[] = [];
  imageBase64: any;

  constructor(
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoadingBarService,
    public notificationService: NotificationService,
    public globals: Globals,
    public cookieService: CookieService,
    public router: Router,
    public _productsService: ProductsService,
    public _imagesService: ImagesService,
    public confirmationService: ConfirmationService,
    public lightbox: Lightbox
  ) {
    // Get Patient id from params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productId = params.id;
    });

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/products/', title: 'All Products', class: 'back-link' },
      { path: '/' + this.routeRole + '/products/' + this.productId + '/details', title: 'Details' },
      { path: '/' + this.routeRole + '/products/' + this.productId + '/images', title: 'Images' },
      {
        path: '/' + this.routeRole + '/products/' + this.productId + '/nutrition',
        title: 'Nutrition',
      },
      {
        path: '/' + this.routeRole + '/products/' + this.productId + '/ingredients-allergens',
        title: 'Ingredients & Allergens',
      },
    ];
  }

  ngOnInit() {
    this.getProduct(this.productId);
  }

  // Get Product by id
  public getProduct(id) {
    this._productsService.getProductById(id).subscribe((data: any) => {
      console.log('Indi Product ', data);
      this.selectedProduct = data;
      if (this.selectedProduct.featuredImage !== null) {
        this.selectedProduct.featuredImageObj = this.selectedProduct.featuredImage;
        this.selectedProduct.featuredImage =
          environment.dcSpacesUrl +
          'images/' +
          this.storeId +
          '/' +
          this.selectedProduct.featuredImage.name;
      }
      if (this.selectedProduct.images.length > 0) {
        this.selectedProductImagesArray = [];
        this.selectedProduct.images.forEach((element) => {
          const imageUrl = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name;
          const body = {
            imageData: element,
            imageUrl: imageUrl,
            src: imageUrl,
            thumb: imageUrl,
          };

          this.selectedProductImagesArray.push(body);
        });
      }
    });
  }

  // Toggle Media Modal, accounting for param
  public toggleAddMediaModal(type) {
    this.mediaUploadType = type;
    this.addMediaModal = !this.addMediaModal;
    this.getImages(this.storeId);
  }

  // Get All Images
  public getImages(id) {
    this.imagesArray = [];
    this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
      this.imagesArray = [];
      console.log(data);
      data.forEach((element) => {
        const obj = {
          imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          imageData: element,
        };
        this.imagesArray.push(obj);
      });
    });
  }

  public selectImageBankImage(image) {
    console.log('Image to attach - ', image);
    if (this.mediaUploadType === 'featured') {
      this._imagesService
        .addFeaturedImageToProduct(this.selectedProduct.id, image.imageData.id)
        .subscribe((data: any) => {
          console.log('Attach Image Response - ', data);
          this.toggleAddMediaModal('');
          this.getProduct(this.productId);
          this.notificationService.notify(
            'success',
            'Image Added',
            'Products Featured Image has successfully been updated',
            'top',
            'right'
          );
        });
    } else {
      this._imagesService
        .addImageToProduct(this.selectedProduct.id, image.imageData.id)
        .subscribe((data: any) => {
          console.log('Attach Image Response - ', data);
          this.toggleAddMediaModal('');
          this.getProduct(this.productId);
          this.notificationService.notify(
            'success',
            'Image Added',
            'Product Image has successfully been updated',
            'top',
            'right'
          );
        });
    }
  }

  // Uploading
  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      const myReader: FileReader = new FileReader();
      const that = this;
      if (this.mediaUploadType === 'featured') {
        myReader.onloadend = function (loadEvent: any) {
          const fileObj = {
            fileName: event.target.files[i].name,
            imageBase64: loadEvent.target.result,
            itemCategoryId: null,
            itemFeaturedItemId: that.selectedProduct.id,
            itemImageItemId: null,
            storeFeaturedImageStoreId: null,
            storeId: that.storeId,
            storeLogoStoreId: null,
          };
          that.imageBase64 = fileObj;
          that.uploadImage(fileObj);
        };
        myReader.readAsDataURL(file);
      } else {
        myReader.onloadend = function (loadEvent: any) {
          const fileObj = {
            fileName: event.target.files[i].name,
            imageBase64: loadEvent.target.result,
            itemCategoryId: null,
            itemFeaturedItemId: null,
            itemImageItemId: that.selectedProduct.id,
            storeFeaturedImageStoreId: null,
            storeId: that.storeId,
            storeLogoStoreId: null,
          };
          that.imageBase64 = fileObj;
          that.uploadImage(fileObj);
        };
        myReader.readAsDataURL(file);
      }
    }
  }

  public uploadImage(fileObj) {
    this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
      this.imagesArray = [];
      this.getImages(this.storeId);
      this.getProduct(this.productId);
      this.notificationService.notify(
        'success',
        'Image Uploaded',
        'Image Successfully Uploaded',
        'top',
        'right'
      );
    });
  }

  public removeImage(image, type) {
    console.log('Remove products Image - ', type);
    console.log('Remove image - image - ', image);
    console.log('this.selectedProduct', this.selectedProduct);
    console.log('this.productId', this.productId);
    if (type === 'featured') {
      const body = {
        imageId: this.selectedProduct.featuredImageObj.id,
        itemFeaturedItemId: this.productId,
      };
      this.confirmationService.confirm({
        message:
          'Are you sure that you want to remove product featured image? It will not be deleted from Image bank.',
        accept: () => {
          this._imagesService.removeImageLink(body).subscribe((data: any) => {
            console.log(data);
            this.getProduct(this.productId);
          });
        },
      });
    } else {
      const body = {
        imageId: image.imageData.id,
        itemImageItemId: this.productId,
      };
      this.confirmationService.confirm({
        message:
          'Are you sure that you want to remove product image? It will not be deleted from Image bank.',
        accept: () => {
          this._imagesService.removeImageLink(body).subscribe((data: any) => {
            console.log(data);
            this.getProduct(this.productId);
          });
        },
      });
    }
  }

  open(index: number): void {
    console.log('this.selectedProductImagesArray', this.selectedProductImagesArray);
    console.log('index', index);
    // open lightbox
    this.lightbox.open(this.selectedProductImagesArray, index, {
      centerVertically: true,
      disableScrolling: true,
      showImageNumberLabel: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/single-product/images/product-images.component.ts